








































































































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import {
  Alert, NoticeClass, AuthStore, Dialog,
} from '@kasasa/fbase-components/lib';
import {
  KNoticeContainer,
} from '@kasasa/fbase-components';
import {
  RewardsValidationResource, NonTransactionDataSnapshot, ValueWithThresholds, CycleTransactionCount, CycleValidationSnapshot, ValidationSnapshot,
} from '@/api/rewardsvalidation/';
import { Cycle } from '@/api/cycles';


@Component({
  computed: mapState(['fiId']),
})
export default class EOCDataPointsCard extends Vue {
  @Prop() data!: NonTransactionDataSnapshot;

  @Prop() currentTransactionCount!: CycleTransactionCount;

  @Prop() cycles!: Cycle[];

  fiId!: string;

  previousTransactionCount: number | null = null;

  loading: boolean = false;

  @Inject('RewardsValidationResource')
  rewardsValidationResource!: RewardsValidationResource;

  mounted() {
    this.getPreviousCycleTransactionCount();
  }

  @Watch('cycles')
  getPreviousCycleTransactionCount() {
    this.loading = true;
    this.previousTransactionCount = 0;
    if (this.cycles && this.cycles.length > 1) {
      // Last cycle is the one we're displaying, second last is previous.
      this.rewardsValidationResource.getCycleValidationSnapshot(this.fiId, this.cycles[this.cycles.length - 2].id).then((snapshot: CycleValidationSnapshot) => {
        const validation: ValidationSnapshot | null = EOCDataPointsCard.parseSnapshot(snapshot);
        if (validation) {
          validation.transactionCounts.every((count: CycleTransactionCount) => {
            if (count.transactionType === 'TOTAL_TRANSACTIONS') {
              this.previousTransactionCount = count.count;
              return false;
            }
            return true;
          });
        }
      }).catch((error: any) => {
        if (error.response && error.response.status !== 404) {
          this.showErrorMessage(error);
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }

  static parseSnapshot(snapshot: CycleValidationSnapshot): ValidationSnapshot | null {
    // Newer snapshots are instances of ValidationSnapshot.  Older ones are just arrays of ValidationProduct.
    const parsedObj: any = JSON.parse(snapshot.jsonString);

    if (Array.isArray(parsedObj)) {
      // This is an old snapshot that does not contain transaction data. It's of no use to us.
      return null;
    }

    return parsedObj as ValidationSnapshot;
  }

  getClassForValueWithThresholds = (value: ValueWithThresholds): string => EOCDataPointsCard.getClassForPercentageValue(value.value, value.yellowThresholdMinimum, value.greenThresholdMinimum,
    value.greenThresholdMaximum, value.yellowThresholdMaximum)

  getClassForTransactionCountPercentageValue(): string {
    return EOCDataPointsCard.getClassForPercentageValue(this.currentTransactionCount.count, this.currentTransactionCount.yellowThresholdMinimum,
      this.currentTransactionCount.greenThresholdMinimum, this.currentTransactionCount.greenThresholdMaximum, this.currentTransactionCount.yellowThresholdMaximum);
  }

  static getClassForPercentageValue(value: number, yellowThresholdMinimum: number | null, greenThresholdMinimum: number | null,
    greenThresholdMaximum: number | null, yellowThresholdMaximum: number | null): string {
    let classNames: string = '';

    if (yellowThresholdMinimum && yellowThresholdMaximum && greenThresholdMinimum && greenThresholdMaximum) {
      if (value < greenThresholdMinimum || value > greenThresholdMaximum) {
        if (value < yellowThresholdMinimum || value > yellowThresholdMaximum) {
          classNames += ' redText';
        } else {
          classNames += ' yellowText';
        }
      } else {
        classNames += ' greenText';
      }
    } else {
      classNames += ' blueText';
    }

    return classNames;
  }

  getPercentageValue = (value: number, previousValue: number): string => {
    let resultText = previousValue > value ? '' : '+';

    const percentage: number = ((value - previousValue) / previousValue) * 100;

    if (percentage < 1 && percentage > -1) {
      resultText += `${percentage.toFixed(1)}%`;
    } else {
      resultText += `${percentage.toFixed(0)}%`;
    }

    return resultText;
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
